var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoungeCafe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E8BFF",
    d: "M8 14h20l-1.792 15.234C26.089 30.24 25.236 31 24.222 31H11.778c-1.014 0-1.867-.76-1.986-1.766L8 14z",
    transform: "translate(-204 -258) translate(192 248) translate(12 10)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F73F3",
    d: "M7 9h22c.552 0 1 .448 1 1v3c0 .552-.448 1-1 1H7c-.552 0-1-.448-1-1v-3c0-.552.448-1 1-1zM10.471 4.918l14.722-.823c.978-.055 1.852.607 2.064 1.563L28 9H8l.643-2.57c.212-.85.953-1.463 1.828-1.512z",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(-204 -258) translate(192 248) translate(12 10)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 17L15 25 21 25 21 17z",
    transform: "translate(-204 -258) translate(192 248) translate(12 10)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoungeCafe);
export default __webpack_public_path__ + "static/media/lounge-cafe.c5ccd002.svg";
export { ForwardRef as ReactComponent };